import { ModalDialog } from "@story/story_assets/modal/modal_dialog";

import { parseLocalizedInt } from "../utils/numbers";

document.addEventSelectorListener("ajaxsuccess", "form[data-modal='submit']", function(event, target) {
	let modal = ModalDialog.get();
	modal.innerHTML = event.detail.response;

	let modalClass = event.detail.xhr.getResponseHeader("Ajax-Modal-Class");
	if (modalClass) {
		modal.element.setAttribute("class", modal.element.getAttribute("class") + " " + modalClass);
	}

	modal.open();
});


document.addEventSelectorListener("click change", "input[data-gift]", function(event, target) {
	let amount = parseLocalizedInt(target.getAttribute("data-gift"));
	let input = target.closest("form").querySelector("input[data-gift-amount]");
	// let value = story.parseInt(input.value);

	input.setAttribute("data-min", amount);

	// if (value < amount) {
	input.value = amount;
	input.trigger("change");
	// }
});